import { Box } from "@mui/material"

import { AiOutlineFilePdf } from "react-icons/ai"
import { MdFileDownload } from "react-icons/md"

const DownloadItem = ({ name, url }: Props) => {
	return (
		<a href={url} target="_blank" rel="noreferrer noopener" style={{ textDecoration: "none" }}>
			<button
				style={{
					display: "flex",
					alignItems: "center",
					background: "#fff",
					width: "inherit",
					textAlign: "left",
					padding: 0,
					borderRadius: 10,
					border: "none",
					outline: "none",
					cursor: "pointer",
					marginTop: 30,
				}}
			>
				<AiOutlineFilePdf size="2rem" color="#009CAC" style={{ marginLeft: 10 }} />
				<Box pl={2} pr={3} style={{ color: "black" }}>
					<div>
						<strong>Bedienungsanleitung</strong>
					</div>
					<div>{name}</div>
				</Box>
				<Box
					p={1}
					style={{
						background: "#009CAC",
						borderTopRightRadius: 5,
						borderBottomRightRadius: 5,
					}}
				>
					<MdFileDownload size="2rem" color="#fff" />
				</Box>
			</button>
		</a>
	)
}

interface Props {
	name: string
	url: string
}

export default DownloadItem
